import { BASELINE } from './typography';

export const space = [0, 1, 2, 4, 8].map((s) => s * BASELINE);

export default space;
